export default "__VITE_ASSET__1FoCVcBr__"